import {showNotification} from 'platform/components';

import {useUpdateInspectionStructureToLatestVersionMutation} from '@dms/api/core';
import i18n from '@dms/i18n';
import {handleApiError} from '@dms/shared';

import {useFetchAuditWithAuditStructure} from './useFetchAuditWithAuditStructure';

export function useUpdateInspectionStructure(inspectionId: string) {
  const {fetchAuditWithAuditStructure} = useFetchAuditWithAuditStructure(inspectionId);
  const [updateInspectionStructure, {isLoading}] =
    useUpdateInspectionStructureToLatestVersionMutation();

  const handleUpdateInspectionStructure = () => {
    updateInspectionStructure({inspectionId})
      .unwrap()
      .then(() => fetchAuditWithAuditStructure())
      .then(() => {
        showNotification.success(i18n.t('entity.inspection.notifications.structureUpdated'));
      })
      .catch((error: Error) => {
        showNotification.error(i18n.t('entity.inspection.notifications.structureUpdateFailed'));
        handleApiError(error, {silent: true});
      });
  };

  return {
    isLoading,
    updateInspectionStructure: handleUpdateInspectionStructure,
  };
}
